import { Vendor, DateRange } from '../types/types';
import { format, startOfDay, max, min, eachDayOfInterval } from 'date-fns';

interface DateWithVendors {
  date: Date;
  dateStr: string;
  vendorCount: number;
}

export function getDatesWithVendors(vendors: Vendor[], apiDateRange: DateRange): DateWithVendors[] {
  const today = startOfDay(new Date());
  const forecastEndDate = apiDateRange.endDate;

  // Generate all dates in the API range
  const allDatesInRange = eachDayOfInterval({
    start: today,
    end: forecastEndDate,
  });

  // Count vendors for each date
  const vendorCountByDate = new Map<string, number>();

  // If there are vendors, count them per date
  if (vendors?.length) {
    vendors.forEach(vendor => {
      if (!vendor) return;

      const vendorStartDate = vendor.start_date ? new Date(vendor.start_date + 'T00:00:00') : today;
      const vendorEndDate = vendor.expiry ? new Date(vendor.expiry + 'T23:59:59') : forecastEndDate;

      const calculationStartDate = max([today, vendorStartDate]);
      const calculationEndDate = min([vendorEndDate, forecastEndDate]);

      if (calculationStartDate > calculationEndDate) {
        return;
      }

      const vendorDatesInRange = eachDayOfInterval({
        start: calculationStartDate,
        end: calculationEndDate,
      });

      const validDates = vendorDatesInRange.filter(date => {
        const jsDay = date.getDay();
        const dbDay = jsDay === 0 ? 7 : jsDay;
        return vendor.schedule.days.includes(dbDay);
      });

      validDates.forEach(date => {
        const dateStr = format(date, 'yyyy-MM-dd');
        vendorCountByDate.set(dateStr, (vendorCountByDate.get(dateStr) || 0) + 1);
      });
    });
  }

  // Map all dates with their vendor counts
  const datesWithVendors = allDatesInRange.map(date => {
    const dateStr = format(date, 'yyyy-MM-dd');
    return {
      date,
      dateStr,
      vendorCount: vendorCountByDate.get(dateStr) || 0,
    };
  });

  return datesWithVendors;
}
